export default __webpack_public_path__ + "static/mandarn-oriental-condo-988952_1280-06e3a2b958f1d4dd9d0e895a3db3c871.png";